export const ACTIONS = {
  RECORD_CLIENT_EVENT: 'RECORD_CLIENT_EVENT',
  CLEAR_CLIENT_EVENTS: 'CLEAR_CLIENT_EVENTS',
};

export const publishClientEvent = data => ({
  type: ACTIONS.RECORD_CLIENT_EVENT,
  payload: data,
});

export const clearClientEvents = ids => ({
  type: ACTIONS.CLEAR_CLIENT_EVENTS,
  payload: {
    eventIds: ids,
  },
});
